import { render, staticRenderFns } from "./MentoringPackages.vue?vue&type=template&id=2a973aed&"
import script from "./MentoringPackages.vue?vue&type=script&lang=js&"
export * from "./MentoringPackages.vue?vue&type=script&lang=js&"
import style0 from "./MentoringPackages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports